export enum CMSIntroductionLayout {
  FullBleed = 'FLIGHT_CLUB_INTRODUCTION_LAYOUT_FULL_BLEED',
  FullBleedVideo = 'FLIGHT_CLUB_INTRODUCTION_LAYOUT_FULL_BLEED_VIDEO',
  Image = 'FLIGHT_CLUB_INTRODUCTION_LAYOUT_IMAGE',
  Text = 'FLIGHT_CLUB_INTRODUCTION_LAYOUT_TEXT',
}
